<template>
  <div id="app">
    <div class="navbar navbar-default">
      <div class="container">
        <div class="text-center header-text" v-on:click="toggleFullScreen">Johku Reader<span class="glyphicon glyphicon-fullscreen pull-right"></span></div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    toggleFullScreen: function () {
      var doc = window.document;
      var docEl = doc.documentElement;
      
      var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
      var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen
      
      if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl)
      }
      else {
        cancelFullScreen.call(doc)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue